import { createContext } from "react";
import type { MutableRefObject } from "react";
import type { TabProps } from "../Tab";

export type TabMeta = Omit<TabProps, "children">;

export interface TabRegistry {
  metaRef: MutableRefObject<TabMeta[]>;
  activeId: string;
}

export const TabRegistryContext = createContext<TabRegistry | undefined>(
  undefined,
);
